import { render, staticRenderFns } from "./PayStatement.vue?vue&type=template&id=687973ef&scoped=true"
import script from "./PayStatement.vue?vue&type=script&lang=ts"
export * from "./PayStatement.vue?vue&type=script&lang=ts"
import style0 from "./PayStatement.vue?vue&type=style&index=0&id=687973ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687973ef",
  null
  
)

export default component.exports